import LoadingAnimation from 'components/Common/Loading/LoadingAnimation'
import Group from 'components/utils/Group'
import FlightDealsGrid from 'home/components/FlightDeals/FlightDealsGrid/FlightsDealsGrid'
import useFlightDealLocations from 'home/hooks/useFlightDealLocations'
import useFlightDeals from 'hooks/Flights/useFlightDeals'
import React, { useState } from 'react'
import { useIntl } from 'react-intl'

export default function FlightCampaignsAllDeals() {
  const intl = useIntl()
  const [deals, loading] = useFlightDeals()
  const [airports, defaultAirport] = useFlightDealLocations()
  const [selectedAirport, setSelectedAirport] = useState<App.Airport>()

  const flightDealsTitle = intl.formatMessage({
    id: 'fwZnErFc52',
    defaultMessage: 'Flight deals from',
    description: 'Title for the flight deals grid section on campaigns page',
  })

  const showDeals = deals.length > 0 && !loading

  return (
    <>
      {loading && (
        <Group direction="horizontal" verticalAlign="center" horizontalAlign="center">
          <LoadingAnimation />
        </Group>
      )}

      {showDeals && (
        <FlightDealsGrid
          flightDeals={deals}
          airports={airports}
          defaultAirport={defaultAirport}
          onAirportChange={setSelectedAirport}
          selectedAirport={selectedAirport}
          title={flightDealsTitle}
        />
      )}
    </>
  )
}
